import { MinMaxAge } from "@/modules/common/common/models/APP/MinMaxAge"

export class PetsHiringMaxAges {
  holderNotInsured: MinMaxAge
  pets: MinMaxAge
  insuredRC: MinMaxAge
  constructor(data: any = {}) {
    this.holderNotInsured = new MinMaxAge(data.holderNotInsured)
    this.pets = new MinMaxAge(data.pets)
    this.insuredRC = new MinMaxAge(data.insuredRC)
  }
}
